import { mdiDomain } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "properties",
  title: "Liegenschaften",
  tooltip: "Liegenschaften mit Adressen, Wohneinheiten und zugehörigen Ansprechpartnern pflegen.",
  icon: mdiDomain,
  routeSegment: "properties",
  // Same projection as the registry read admission (kehrblatt.registry:view).
  getPages: (context) =>
    context.permissions.allows("kehrblatt.registry", "view")
      ? [
          {
            id: "properties",
            title: "Liegenschaften",
            path: "",
          },
        ]
      : [],
}
